document.addEventListener('DOMContentLoaded', function() {
    let version = 'globo'; // globo or liquid
    var container = '';

    console.log('version 14. ' + version);

    if (version === 'globo') {
        container = '.collection-grid__wrapper';
        console.log('version globo');
    } else {
        container = '.product-recommendations';
        console.log('version shopify script');
    }

    // Check if URL includes 'collection' or 'search'
    if (!(window.location.href.includes('collection') || window.location.href.includes('search'))) {
        console.log('This page is neither a collection nor a search page. Exiting script.');
        return;
    }

    //wishlist script
    console.log('Document ready. Setting up event listeners.');

    // Disable all add to cart buttons initially
    const addToCartButtons = document.querySelectorAll('.custom-button-add');
    // addToCartButtons.forEach(button => {
    //   button.disabled = true;
    //  // console.log('Add to Cart button disabled'); // Added console log for verification
    // });

    document.body.addEventListener('click', function(event) {
        // Handle product color button click
        if (event.target.classList.contains('product-color-btn')) {
            handleProductColorButtonClick(event);
        }

        // Handle size option (swatch) click
        if (event.target.classList.contains('swatch')) {
            handleSwatchClick(event);
        }




    });


    // Function to initialize Flickity for a given element
    function initializeFlickity(element) {
        //console.log('Initializing Flickity for element:', element);
        new Flickity(element, {
            wrapAround: true,
            pageDots: false,
            arrowShape: 'M 10 50 L 60 95 L 65 90 L 21 50 L 65 5 L 60 0 Z',
            on: {
                ready: function(e) {
                    const itemHeight = $(e).outerHeight(),
                        viewport = $(e).find('.flickity-viewport').first();

                    // update view port height in case wrong calculate
                    viewport.css('height', itemHeight);
                },
            }
        });
    }
    
    const initImageSlider = () => {
        // Initialize Flickity for existing products
        const existingCarousels = document.querySelectorAll('.main-carousel');
        //console.log(`Found ${existingCarousels.length} existing carousels`);
        existingCarousels.forEach(carousel => {
            initializeFlickity(carousel);
        });
    }
    initImageSlider();

    document.addEventListener('shopify:section:ajaxContentUpdated', function (event) {
        initImageSlider();
    });

    // New code to handle products on page load
    const gridItems = document.querySelectorAll('.grid__item');
    gridItems.forEach(gridItem => {
        const sizeBtnDiv = gridItem.querySelector('.size-btn');
        if (sizeBtnDiv) {
        } else {

            updateAddToCartButton(null, gridItem);

        }



    });




    // MutationObserver to watch for DOM changes
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.addedNodes) {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('grid__item')) {
                        const carousel = node.querySelector('.main-carousel');
                        const sizeInputs = node.querySelectorAll('input[name="size"]');
                        if (carousel) {
                            initializeFlickity(carousel);
                        }
                        if (sizeInputs.length > 0) {
                            setupCustomValidation(node);
                        }
                        updateButtonStatusLoading();


                    }
                });
            }
        });
    });

    if (version=='globo') {
        // Start observing the container of products for added nodes
        const productContainer = document.querySelector(container); // Replace '.container-selector' with the actual container selector
        if (productContainer) {
            //console.log('Starting to observe product container:', productContainer);
            observer.observe(productContainer, { childList: true, subtree: true });
        } else {
            console.error('Product container not found. Check the selector.');
        }

// Call the setup function for custom validation
    }
    setupCustomValidation(document);

});

// Define the custom validation setup function
function setupCustomValidation(context) {
    const sizeInputs = context.querySelectorAll('input[name="size"]:not(.validation-setup)');

    sizeInputs.forEach(input => {
        input.classList.add('validation-setup'); // Mark the input as set up
        input.addEventListener('invalid', handleInvalidEvent);
        input.addEventListener('change', handleChangeEvent);
    });
}


function reapplyValidation(sizeBtnDiv) {
    const sizeInputs = sizeBtnDiv.querySelectorAll('input[name="size"]');
    sizeInputs.forEach(input => {
        input.addEventListener('invalid', handleInvalidEvent);
        input.addEventListener('change', handleChangeEvent);
    });
}

function revalidateForm(sizeBtnDiv) {
    const form = sizeBtnDiv.closest('form');
    if (form) {
        form.reportValidity();
    }
}

function handleInvalidEvent(event) {
    event.target.setCustomValidity('נא לבחור מידה'); // Always set the custom message
}


function handleChangeEvent(event) {
    document.querySelectorAll('input[name="size"]').forEach(radio => {
        radio.setCustomValidity(''); // Clear custom validity for all size radio buttons
    });
    event.target.form.reportValidity(); // Trigger a re-validation check
}


function handleProductColorButtonClick(event) {
    // ...

    var productHandle = event.target.getAttribute('selected-product-handle');
    const MainParentCard = event.target.closest('.grid-product__content');
    const addToCartButton = MainParentCard.querySelector('.custom-button-add');
    const ImageParentCard = event.target.closest('.grid-product__link');

    if (MainParentCard) {
        var sizeBtnDiv = MainParentCard.querySelector('.size-btn');
        if (sizeBtnDiv) {
            checkProductAvailability(productHandle, sizeBtnDiv, MainParentCard, ImageParentCard);


            // Reset the checked state of size radio buttons
            const sizeRadioButtons = sizeBtnDiv.querySelectorAll('input[type="radio"][name="size"]');
            sizeRadioButtons.forEach(radio => {
                radio.checked = false;
            });
        }



        // New code to handle the selected class for color buttons
        const colorButtonsParent = event.target.closest('.product-color-picker-wrapper');
        if (colorButtonsParent) {
            // Remove 'selected' class from all color buttons
            colorButtonsParent.querySelectorAll('.product-color-btn').forEach(btn => {
                btn.classList.remove('selected');
            });

            // Add 'selected' class to the clicked button
            if (event.target.classList.contains('product-color-btn')) {
                event.target.classList.add('selected');
            }
        }

        updateButtonStatus();
    }



}



function handleSwatchClick(event) {


    const parentCard = event.target.closest('.grid-product__content');
    if (parentCard) {
        const addToCartButton = parentCard.querySelector('.custom-button-add');
        const hiddenInput = parentCard.querySelector('.swatch-hidden');
        const priceDisplay = parentCard.querySelector('.price-product'); // Assuming this is the selector for the price element

        const wishlistButton = parentCard.querySelector('.add-to-wishlist-btn');
        const clickOverlay = parentCard.querySelector('.click-overlay');


        if (clickOverlay) {
            clickOverlay.style.display = 'none'; // Hide the overlay when the button is "enabled"
        }




        if (addToCartButton) {
            addToCartButton.disabled = false;
        }

        if (hiddenInput && event.target.id.startsWith('swatch-')) {
            hiddenInput.value = event.target.id.replace('swatch-', '');
            let variantId= event.target.id.replace('swatch-', '');

            if (wishlistButton) wishlistButton.setAttribute('data-variant-id', variantId);

            // Update the price display
            if (priceDisplay) {
                var selectedVariantId = hiddenInput.value;
                var variantRadio = document.getElementById(event.target.id);
                var variantPrice = variantRadio.getAttribute('data-price');
                priceDisplay.textContent = variantPrice;
            }
        }
    }

    updateButtonStatus();

}

function updateSecondaryImage(product, parentCard) {
    var commonParent = parentCard.closest('.grid-product__content');

    // Select all secondary image elements you want to update
    var secondaryImageElements = commonParent.querySelectorAll('.grid-product__secondary-image img, .image-wrap-mobile-second img');

    // Function to update image source and srcset
    function updateImageElement(imageElement, imageUrl) {
        if (imageElement && imageUrl) {
            // Update the main source
            imageElement.src = imageUrl;

            // Update srcset
            const sizes = ["180x", "360x", "540x", "720x", "900x", "1080x", "1296x", "1512x", "1728x", "1944x", "2160x", "2376x", "2592x", "2808x", "3024x"];
            let newSrcset = sizes.map(size => {
                let newUrl = imageUrl.split('?')[0]; // Remove any query parameters like version
                newUrl = newUrl.replace(/(\d+x)/, size); // Replace size in URL
                return `${newUrl} ${size}`;
            }).join(', ');

            imageElement.setAttribute('srcset', newSrcset);

            //console.log('Image updated:', imageElement);
        }
    }

    // Update each secondary image element
    secondaryImageElements.forEach(imageElement => {

        if (product.images[1]) {
            updateImageElement(imageElement, product.images[1]);

        } else {
            updateImageElement(imageElement, product.images[0]);


        }

    });
}

function updateProductLinksHref(parentCard, productHandle) {
    var commonParent = parentCard.closest('.grid-product__content');

    // Find all anchor tags with class 'grid-product__link' within the parent element
    var productLinks = commonParent.querySelectorAll('a.grid-product__link');

    // Iterate through each product link and update the href attribute
    productLinks.forEach(function(link) {
        link.href = '/products/' + productHandle;
        console.log('Updated href for product link:', link.href);
    });
}

function updateMainImage(product, parentCard) {
    var commonParent = parentCard.closest('.grid-product__content');

    var secondaryImageElementMobile = commonParent.querySelector('.image-wrap-mobile img');
    var secondaryImageElementDesktop = commonParent.querySelector('.image-wrap.main-carousel-desktop img');

    // Function to update image source and srcset
    function updateImageElement(imageElement, imageUrl) {
        if (imageElement && imageUrl) {
            // Update the main source
            imageElement.src = imageUrl;

            // Update srcset
            const sizes = ["180x", "360x", "540x", "720x", "900x", "1080x", "1296x", "1512x", "1728x", "1944x", "2160x", "2376x", "2592x", "2808x", "3024x"];
            let newSrcset = sizes.map(size => {
                let newUrl = imageUrl.split('?')[0]; // Remove any query parameters like version
                newUrl = newUrl.replace(/(\d+x)/, size); // Replace size in URL
                return `${newUrl} ${size}`;
            }).join(', ');

            imageElement.setAttribute('srcset', newSrcset);

            //console.log('Image updated:', imageElement);
        }
    }

    // Update mobile and desktop images if available
    updateImageElement(secondaryImageElementMobile, product.images[0]);
    updateImageElement(secondaryImageElementDesktop, product.images[0]);
}


function formatMoney(amount) {
    // Convert cents to Shekels and format to 2 decimal places
    var formattedAmount = (amount / 100).toFixed(2);
    // Return the formatted amount with the currency symbol ₪
    return `${formattedAmount} ₪`;
}



function updatePriceDisplay(product, parentCard) {
    var priceProductDiv = parentCard.querySelector('.price-product');
    var originalPriceSpan = parentCard.querySelector('.grid-product__price--original');
    var priceSavingsSpan = parentCard.querySelector('.grid-product__price--savings');

    if (priceProductDiv) {
        priceProductDiv.textContent = formatMoney(product.price_min);
    }

    if (product.compare_at_price_min > product.price_min) {
        if (originalPriceSpan) {
            originalPriceSpan.textContent = formatMoney(product.compare_at_price_min);
            originalPriceSpan.style.display = ''; // Show if it was previously hidden
        } else {
            // Create the original price span if it doesn't exist
            const newOriginalPriceSpan = document.createElement('span');
            newOriginalPriceSpan.classList.add('grid-product__price--original');
            newOriginalPriceSpan.textContent = formatMoney(product.compare_at_price_min);
            priceProductDiv.parentNode.insertBefore(newOriginalPriceSpan, priceProductDiv.nextSibling);
        }
        if (priceSavingsSpan) {
            let savedAmount = formatMoney(product.compare_at_price_min - product.price_min);
            priceSavingsSpan.textContent = `Save ${savedAmount}`;
            priceSavingsSpan.style.display = ''; // Show savings span
        }
    } else {
        // Hide or remove the original price and savings span if the compare_at_price is not greater
        if (originalPriceSpan) {
            originalPriceSpan.style.display = 'none';
        }
        if (priceSavingsSpan) {
            priceSavingsSpan.style.display = 'none';
        }
    }
}

function formatMoney(amount) {
    return `${parseFloat(amount / 100).toFixed(2)} ₪`; // Convert cents to Shekels and format
}


function formatMoney(amount) {
    return `${parseFloat(amount / 100).toFixed(2)} ₪`; // Convert cents to Shekels and format
}



function checkProductAvailability(productHandle, sizeBtnDiv, parentCard, ImageParentCard) {
    var url = '/products/' + productHandle + '.js';
    fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Product not found');
            }
            return response.json();
        })
        .then(product => {
            //console.log("product", product);

            // Find the first available variant and update the hidden input
            const firstAvailableVariant = product.variants.find(variant => variant.available);
            const wishlistButton = parentCard.querySelector('.add-to-wishlist-btn');


            const hiddenInput = parentCard.querySelector('.swatch-hidden');

            if (firstAvailableVariant && hiddenInput) {
                hiddenInput.value = firstAvailableVariant.id;

                if (wishlistButton) wishlistButton.setAttribute('data-variant-id', `${firstAvailableVariant.id}`);
                if (wishlistButton) wishlistButton.setAttribute('data-product-id', `${product.id}`);
                if (wishlistButton) wishlistButton.setAttribute('data-handle', `${product.handle}`);
                updateButtonStatus();
                //console.log('First available Variant ID updated to:', firstAvailableVariant.id);
            } else {
                hiddenInput.value = '0';



            }
            updateProductLinksHref(parentCard, productHandle);
            updateSizeOptions(product, sizeBtnDiv, parentCard);

            updateAddToCartButton(product, parentCard);
            updateMainImage(product, parentCard);
            updateSecondaryImage(product, parentCard);
            updatePriceDisplay(product, parentCard);
        })
        .catch(error => {
            console.error('Error fetching product data:', error);

            // Disable the color button related to this product
            if (parentCard) {
                const colorButton = parentCard.querySelector('.product-color-btn[selected-product-handle="' + productHandle + '"]');
                if (colorButton) {
                    colorButton.disabled = true;
                    colorButton.classList.add('disabled'); // Assuming you have a 'disabled' class
                }
            }
        });
}


function updateAddToCartButton(product, parentCard) {
    const addToCartButton = parentCard.querySelector('.custom-button-add');
    if (!addToCartButton) return;

    if (product) {
        console.log('Product:', product);
        const firstAvailableVariant = product.variants.find(variant => variant.available);
        console.log('First available Variant:', firstAvailableVariant);

        if (firstAvailableVariant) {
            addToCartButton.classList.remove('disabled'); // Optionally, remove the 'disabled' class if you're using it for styling
            addToCartButton.disabled = false; // Enable the button by setting the disabled property to false
            addToCartButton.textContent = 'הוספה לסל';
        } else {
            addToCartButton.classList.add('disabled'); // Optionally, add the 'disabled' class for styling purposes
            addToCartButton.disabled = true; // Disable the button by setting the disabled property to true
            addToCartButton.textContent = 'אזל המלאי';
        }
    } else {
        addToCartButton.classList.add('disabled'); // Optionally, add the 'disabled' class for styling
        addToCartButton.disabled = true; // Disable the button as there's no product
        addToCartButton.textContent = 'אזל המלאי';
    }
}



function updateSizeOptions(product, sizeBtnDiv, parentCard) {
    let sizeOptionsHTML = '';
    let sizeOptionIndex = -1;
    let existingSwatchHiddenValue = parentCard.querySelector('.swatch-hidden')?.value;

    product.options.forEach(function(option, index) {
        const optionNameLower = option.name.toLowerCase();
        if (optionNameLower === 'size' || optionNameLower === 'מידה' || optionNameLower === 'מידת נעליים') {
            sizeOptionIndex = index;
        }
    });

    if (sizeOptionIndex !== -1) {
        product.variants.forEach(function(variant) {
            const sizeValue = variant.options[sizeOptionIndex];
            const addToCartButton = parentCard.querySelector('.custom-button-add');
            // if (addToCartButton) {
            //   addToCartButton.disabled = false;
            // }
            const variantId = variant.id;
            const variantPrice =  variant.price

            let labelClass = variant.available ? 'variant-picker add_variant_to_cart' : 'variant-picker variant_no_instock';

            if (variant.available)
            {
                sizeOptionsHTML += `<div>
      <input type="radio" name="size" value="${sizeValue}" id="swatch-${variantId}" data-price="${formatMoney(variantPrice)}" class="swatch" required><label for="swatch-${variantId}" class="${labelClass}">${sizeValue}</label>
      </div>`;

            }
            else {
                sizeOptionsHTML += `<div>
      <input type="radio" name="size" value="${sizeValue}" id="swatch-${variantId}" data-price="${formatMoney(variantPrice)}" class="swatch" disabled><label for="swatch-${variantId}" class="${labelClass}">${sizeValue}</label>
      </div>`;


            }
        });
    }

    if (existingSwatchHiddenValue) {
        sizeOptionsHTML += `<input type="hidden" name="id" class="swatch-hidden" value="${existingSwatchHiddenValue}">`;
    }


    sizeBtnDiv.innerHTML = sizeOptionsHTML;
    // Reapply custom validation to new radio buttons
    reapplyValidation(sizeBtnDiv);

    const addToCartButton = parentCard.querySelector('.custom-button-add');
    //  if (addToCartButton) {
    //    addToCartButton.disabled = true;
    //  }
}